import {ReduceStore} from 'flux/utils';
import Dispatcher from '../dispatcher';
import ACTION_TYPES from '../constants/action_types';
import { actions } from '../constants/last_used_configurator/actions';
import {FilterActions} from '../constants/filter/filter_actions';

class LastUsedConfiguratorStoreClass extends ReduceStore {
    getInitialState() {
        return {
            configuratorSource: '',
            configuratorDispatcher: '',
            vehicleNotProvidedComment: '',
            isVehicleProvided: true,
            hasCartProduct: false,
        };
    }

    reduce(state, { source, action }) {
        const { type, payload } = action;

        if (source === ACTION_TYPES.LAST_USED_CONFIGURATOR) {
            switch (type) {
                case actions.SET_VALUE:
                    state.configuratorSource = payload;
                    this.__emitChange();
                    break;
                case actions.SET_CART_FLAG_VALUE:
                    state.hasCartProduct = payload;
                    this.__emitChange();
                    break;
                case actions.SET_IS_VEHICLE_PROVIDED:
                    state.isVehicleProvided = payload;
                    this.__emitChange();
                    break;
                case actions.SET_VEHICLE_NOT_PROVIDED:
                    state.vehicleNotProvidedComment = payload;
                    this.__emitChange();
                    break;
                case actions.SET_DISPATCHER:
                    state.configuratorDispatcher = payload;
                    this.__emitChange();
                    break;
            }
        }

        if (source === ACTION_TYPES.CATALOG_FILTER_LIGHTBOX_VIEW_ACTION) {
            switch (type) {
                case FilterActions.OPEN_LIGHTBOX_FILTER_SECTION:
                    // state.configuratorSource = payload;
                    this.__emitChange();
                    break;
            }
        }

        return state;
    }
}

const LastUsedConfiguratorStore = new LastUsedConfiguratorStoreClass(Dispatcher);
export default LastUsedConfiguratorStore;